/**
 * Korean (KRW) mock entity data for the marketing-site mockups.
 * Row shapes mirror the app's API rows (see shared-site-web/screens/*.js),
 * so the real column definitions and table components can render them.
 */

/** @type {Array<import('../../mock-data.js').MockAccount>} */
export const MOCK_ACCOUNTS_KO = [
	{ id: 'acc-checking', name: '새봄은행', accountType: 'Bank Account', currency: 'KRW', currencySymbol: '\u20A9', currencyDecimalPlaces: 0, balance: 2894000, principal: null, updatedAt: '2026-08-08' },
	{ id: 'acc-savings', name: '정기예금', accountType: 'Bank Account', currency: 'KRW', currencySymbol: '\u20A9', currencyDecimalPlaces: 0, balance: 12600000, principal: null, updatedAt: '2026-08-08' },
	{ id: 'acc-broker', name: '성장형 펀드', accountType: 'Investment Account', currency: 'KRW', currencySymbol: '\u20A9', currencyDecimalPlaces: 0, balance: 38200000, principal: 40406180, updatedAt: '2026-08-08' },
	{ id: 'acc-pension', name: '개인연금', accountType: 'Pension', currency: 'KRW', currencySymbol: '\u20A9', currencyDecimalPlaces: 0, balance: 86000000, principal: null, updatedAt: '2026-08-08' },
	{ id: 'acc-property', name: '우리집', accountType: 'Real Estate', currency: 'KRW', currencySymbol: '\u20A9', currencyDecimalPlaces: 0, balance: 350000000, principal: 275000000, updatedAt: '2026-08-08' },
	{ id: 'acc-flight', name: '항공 마일리지', accountType: 'Points/Miles', currency: 'MILES', currencySymbol: '\u2708', currencyDecimalPlaces: 0, balance: 84620, principal: null, updatedAt: '2026-08-08' },
	{ id: 'acc-credit', name: '리워드 카드', accountType: 'Credit Card', currency: 'KRW', currencySymbol: '\u20A9', currencyDecimalPlaces: 0, balance: 1240000, principal: null, updatedAt: '2026-08-08' },
	{ id: 'acc-joke', name: '보령증권', accountType: 'Investment Account', currency: 'KRW', currencySymbol: '\u20A9', currencyDecimalPlaces: 0, balance: 18500000, principal: 10164840, updatedAt: '2026-08-08' },
];

/**
 * Custom currencies (KRW base) for the currencies use case. MILES and HP
 * carry a manual rate so the currency table shows the manual marker "(M)".
 * @type {Array<import('../../mock-data.js').MockCurrency>}
 */
export const MOCK_CURRENCIES_KO = [
	{ code: 'KRW', isCustom: 0, name: '대한민국 원', symbol: '\u20A9', decimalPlaces: 0, isBase: 1, rate: 1, manualRate: null },
	{ code: 'USD', isCustom: 0, name: '미국 달러', symbol: '$', decimalPlaces: 2, isBase: 0, rate: 1380, manualRate: null },
	{ code: 'MILES', isCustom: 1, name: '항공 마일리지', symbol: '\u2708', decimalPlaces: 0, isBase: 0, rate: 15, manualRate: 15 },
	{ code: 'HP', isCustom: 1, name: '호텔 포인트', symbol: 'P', decimalPlaces: 0, isBase: 0, rate: 8, manualRate: 8 },
	{ code: 'SM', isCustom: 1, name: '등급 마일', symbol: 'SM', decimalPlaces: 0, isBase: 0, rate: 0, manualRate: 0 },
];

/**
 * Everyday currencies (KRW base) with auto-fetched rates for the
 * multi-currency use case.
 * @type {Array<import('../../mock-data.js').MockCurrency>}
 */
export const MOCK_RATES_KO = [
	{ code: 'KRW', isCustom: 0, name: '대한민국 원', symbol: '\u20A9', decimalPlaces: 0, isBase: 1, rate: 1, manualRate: null },
	{ code: 'USD', isCustom: 0, name: '미국 달러', symbol: '$', decimalPlaces: 2, isBase: 0, rate: 1380, manualRate: null },
	{ code: 'JPY', isCustom: 0, name: '일본 엔', symbol: '\u00A5', decimalPlaces: 0, isBase: 0, rate: 9.6, manualRate: null },
	{ code: 'EUR', isCustom: 0, name: '유로', symbol: '\u20AC', decimalPlaces: 2, isBase: 0, rate: 1500, manualRate: null },
	{ code: 'GBP', isCustom: 0, name: '영국 파운드', symbol: '\u00A3', decimalPlaces: 2, isBase: 0, rate: 1750, manualRate: null },
];
